import { serverPATCH } from "@/utils/HttpFunctions";
import useUserStore from "@/utils/Stores/userStore";
import { useNavigate } from "react-router-dom";
import { errorNotfiy, successNotfiy } from "../Global/Toast";
import { accountSettingSchema, onboardingSchema } from "@/schema";
import { useFormik } from "formik";
import { uploadToBucket } from "@/utils/CommonFunctions";
import Modal from "../Global/Modal";
import PrimaryBtn from "../Global/Button";
import { useMutation } from "@tanstack/react-query";
import { CompanyInfo } from "@/pages/AccountSettings/CompanyProfile";
import { usePrompt } from "@/utils/hooks/usePrompt";
import { useEffect, useState } from "react";

export default function CompanyModal({ handleContinue, data, handleLogout }) {
  const navigate = useNavigate();
  const user = useUserStore((state: any) => state.user);
  const [fileUploadLoading, setFileUploadLoading] = useState(false);

  const defaultValues = {
    company_name: "",
    company_website_link: "",
    company_email: "",
    company_phone_number: "",
    company_logo: "",
    company_logo_file: "",
  };
  const initialValues = data
    ? { ...defaultValues, ...data }
    : { ...defaultValues };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: onboardingSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        let temp: any = { ...values };
        if (
          temp.company_logo_file &&
          typeof temp.company_logo_file !== "string"
        ) {
          setFileUploadLoading(true);
          let uploadCompanyLogo = await uploadToBucket(
            [temp.company_logo_file],
            "profile-pictures"
          );
          temp.company_logo = uploadCompanyLogo[0].url;
        }

        Object.keys(temp).forEach((key) => {
          if (
            temp[key] === "" ||
            temp[key] === null ||
            temp[key] === undefined ||
            key == "company_logo_file"
          ) {
            delete temp[key];
          }
        });
        const body = {
          company_details: {
            name: temp.company_name,
            website: temp.company_website_link,
            phone_number: temp.company_phone_number,
            logo: temp.company_logo,
            address: temp.address,
            email: temp.company_email,
          },
        };

        updateMutate(body);
      } catch (err) {
        console.log("Error", err);
      }
    },
  });

  const { mutate: updateMutate, isPending: isUpdatePending } = useMutation({
    mutationFn: (body: { company_details: any }) =>
      serverPATCH("/auth/info/" + user._id, body),
    onError: (error: any, variables, context) => {
      errorNotfiy(
        error?.message || "Something went wrong while updating user Info"
      );
      setFileUploadLoading(false);
    },
    onSuccess: (data, variables, context) => {
      setCustomDirty((customDirty) => !customDirty);
      setFileUploadLoading(false);

      handleContinue({
        ...formik.values, // Keep existing values
        company_logo: data.company_logo,
        company_logo_file: "",
      });
    },
  });
  const { PromptModal, setCustomDirty } = usePrompt(
    "You have unsaved changes. Are you sure you want to leave?",
    formik.dirty
  );

  return (
    <>
      <PromptModal />
      <Modal
        handleClose={() => {}}
        title={"Company Info"}
        central={true}
        description="Please fill in your company info."
        width="max-w-md"
      >
        <form onSubmit={formik.handleSubmit} className="relative mt-4">
          <div className="flex justify-end m-4 absolute -top-[90px] -right-4">
            <button
              className={`px-4 py-2 focus:outline-none font-medium  text-customGreen-text hover:opacity-80`}
              onClick={handleLogout}
              type="button"
            >
              Logout
            </button>
          </div>
          <CompanyInfo
            errors={formik.errors}
            touched={formik.touched}
            values={formik.values}
            handleChange={formik.handleChange}
            handleSubmit={formik.handleSubmit}
            setFieldValue={formik.setFieldValue}
            companyModal={true}
          />

          <div className="flex items-center justify-between pt-4 mx-auto mt-2">
            <button
              className="font-medium text-black-secondary "
              onClick={() => handleContinue(formik.values)}
            >
              Skip for now
            </button>
            <PrimaryBtn
              text={"Continue"}
              type="submit"
              loading={isUpdatePending || fileUploadLoading}
              disabled={isUpdatePending || fileUploadLoading}
            />
          </div>
        </form>
      </Modal>
    </>
  );
}
